export enum RequestStatus {
  WAITING_MANAGER_INPUT = "waiting_manager_input",
  WAITING_QUALIFICATION = "waiting_qualification",
  WAITING_HR_VALIDATION = "waiting_hr_validation",
  WAITING_PRIORITY_CONFIRMATION = "waiting_priority_confirmation",
  REQUEST_REFUSED = "refused",
  PROPOSAL_PENDING = "proposal_pending",
  PROPOSAL_ACCEPTED = "proposal_accepted",
  PROPOSAL_CANCELED = "proposal_canceled",
  PROPOSAL_REFUSED = "proposal_refused",
  NO_VALIDATION_NEEDED = "no_validation_needed",
  WAITING_FINANCING_VALIDATION = "waiting_financing_validation",
  REQUEST_CANCELED = "canceled",
  VALIDATED = "validated",
  ON_HOLD = "on_hold",
  PLANNED = "planned",
}

export enum RequestSessionStatusEnum {
  COMING = "coming",
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
}

export enum RequestFilter {
  TO_PROCESS = "to_process",
  PROCESSED = "processed",
  ALL = "all",
}

export enum RequestDetailSectionEnum {
  MESSAGES = "messages",
}
